// The members screens (slice 2, doc 13 S11 and §5a). The list, view and edit
// are the customer journey screens; the legacy route names showCustomer,
// editCustomer and createCustomer stay as redirects to them. The journey
// routes carry no meta.section: that would switch on the legacy maker-checker
// header.
// an old My Work or Pending Approval link: the Pending page with that list
// (the old `section` and `tab` query keys dropped, any other kept)
function pendingRedirect(to, show) {
    const query = { ...to.query, show };
    delete query.section;
    delete query.tab;
    return { name: 'memberPending', query };
}

const customerRegistrationRoutes = [

    {

        name: 'customerHome',
        path: '',
        component: () => import('./../CustomerJourney/Members/MemberList.vue'),
        meta: {
            auth: true,
            title: 'Members',
            breadcrumb: 'Members',
            permission: ['view member']
        }

    },

    // Pending: what waits for a checker, the maker's drafts and changes, the
    // USSD queue and what the maker sent for approval, one list at a time
    // (?show=approval|drafts|ussd|changes|submitted). Backend
    // docs/customer-module/record/03-Pending-Page.md
    {
        name: 'memberPending',
        path: 'pending',
        component: () => import('./../CustomerJourney/Members/PendingList.vue'),
        meta: {
            auth: true,
            title: 'Pending',
            breadcrumb: 'Pending',
            permission: ['create member', 'update member', 'approve member', 'view member applications']
        }
    },

    // the former My Work and Pending Approval pages: kept by name and path so
    // links, bookmarks and router.push({ name }) open the matching list
    {
        name: 'memberDrafts',
        path: 'drafts',
        redirect: (to) => pendingRedirect(to, { new: 'drafts', ussd: 'self', changes: 'changes', submitted: 'submitted' }[to.query.section] || 'drafts')
    },
    {
        name: 'memberApprovals',
        path: 'approvals',
        redirect: (to) => pendingRedirect(to, 'approval')
    },

    {
        path: 'blacklist',
        name: 'blacklistHome',
        component: () => import('./Blacklist/ListBlacklist.vue'),
        meta: {
            auth: true,
            title: 'Blacklisted Customers',
            breadcrumb: 'Blacklisted Customers',
            permission: ['view blacklist'],
            section: 'customer'
        }
    },

    {
        path: 'loans/:customerId',
        name: 'memberLoans',
        component: () => import('./../../DepositLoan/Loan/ListCustomerLoans.vue'),
        meta: {
            auth: true,
            title: 'Showing Customer Loans',
            breadcrumb: 'Showing Customer Loans',
            permission: ['view member']
        }
    },

    {
        path: 'deposits/:customerId',
        name: 'memberDeposits',
        component: () => import('./../../DepositLoan/DepositAccount/ListDepositAccounts.vue'),
        meta: {
            auth: true,
            title: 'Showing Customer Deposits',
            breadcrumb: 'Showing Current Accounts',
            permission: ['view member']
        }
    },

    {
        path: 'shares/:customerId',
        name: 'memberShares',
        component: () => import('./../../DepositLoan/ShareDepositAccount/ListSharesAccounts.vue'),
        meta: {
            auth: true,
            title: 'Showing Customer Shares',
            breadcrumb: 'Showing Customer Shares',
            permission: ['view member']
        }
    },

    // legacy name: the list opens the "New member" dialog
    {
        path: 'create',
        name: 'createCustomer',
        redirect: { name: 'customerHome', query: { new: 1 } }
    },

    {
        path: ':id',
        name: 'memberView',
        component: () => import('./../CustomerJourney/Members/MemberFlow.vue'),
        props: { mode: 'view' },
        meta: {
            auth: true,
            title: 'Member',
            breadcrumb: 'Member',
            permission: ['view member']
        }
    },

    {
        path: ':id/edit',
        name: 'memberEdit',
        component: () => import('./../CustomerJourney/Members/MemberFlow.vue'),
        props: { mode: 'edit' },
        meta: {
            auth: true,
            title: 'Edit Member',
            breadcrumb: 'Edit Member',
            permission: ['update member']
        }
    },

    // legacy names, kept for the links that still use them
    {
        path: 'show/:id',
        name: 'showCustomer',
        redirect: (to) => ({ name: 'memberView', params: { id: to.params.id } })
    },

    {
        path: 'edit/:id',
        name: 'editCustomer',
        redirect: (to) => ({ name: 'memberEdit', params: { id: to.params.id } })
    },

    {
        path: 'consolidatedstatement/:id',
        name: 'consolidatedstatement',
        component: () => import('./ConsolidatedStatement.vue'),
        meta: {
            auth: true,
            title: 'Consolidated Statement',
            breadcrumb: 'Consolidated Statement',
            permission: ['view member']
        }
    },

    {
        path: 'delete/:id',
        name: 'deleteCustomer',
        meta: {
            auth: true,
            makerChecker: true,
            title: 'Delete Member',
            permission: ['delete member'],
            section: 'customer'
        }
    },



];

export default customerRegistrationRoutes;
